import React, { Component } from 'react';
import { Control, Form, Errors } from 'react-redux-form';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from '../common/LoadingComponent';
import Flatpickr from 'react-flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
import 'flatpickr/dist/flatpickr.min.css';
import SocialLogin from '../common/SocialLoginComponent';

const required   = (val) => val && val.length;
const maxLength  = (len) => (val) => !(val) || (val.length <= len);
const minLength  = (len) => (val) => val && (val.length >= len);
const isNumber   = (val) => !isNaN(Number(val));
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

const STEPS = ['Identité', 'Accès', 'Naissance', 'Téléphone'];

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = { currentStep: 0, birthDate: null };
        this.handleRegister = this.handleRegister.bind(this);
        this.nextStepForm   = this.nextStepForm.bind(this);
        this.handleBirthDateChange = this.handleBirthDateChange.bind(this);
        this.props.resetRegisterForm();
    }

    handleBirthDateChange(data) { this.setState({ birthDate: data }); }
    nextStepForm() { this.setState({ currentStep: this.state.currentStep + 1 }); }
    handleRegister(values) { this.props.register({ ...values, birthDate: this.state.birthDate }); this.props.resetRegisterForm(); }

    render() {
        const { currentStep } = this.state;

        if (this.props.isRegister) {
            return (
                <div className="auth-page">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-5">
                                <div className="auth-card text-center"><Loading /></div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (this.props.responseRegister) {
            return (
                <div className="auth-page">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-5">
                                <div className="auth-card text-center">
                                    <div style={{ fontSize: '3rem', marginBottom: 16 }}>🎉</div>
                                    <h2 className="auth-title">Bienvenue sur eudeliv !</h2>
                                    <p className="auth-subtitle">Votre compte a été créé avec succès. Vous pouvez maintenant vous connecter.</p>
                                    <Link to="/login">
                                        <Button color="primary" className="auth-submit">Se connecter</Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="auth-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-5 col-lg-4">
                            <div className="auth-card">
                                <Link to="/home" className="auth-logo">eudeliv</Link>
                                <h1 className="auth-title">Rejoignez eudeliv</h1>
                                <p className="auth-subtitle">Créez votre compte en quelques secondes.</p>

                                {/* Étapes */}
                                <div className="steps-indicator mb-4">
                                    {STEPS.map((label, i) => (
                                        <React.Fragment key={i}>
                                            <div style={{ textAlign: 'center' }}>
                                                <div className={`step-dot ${i < currentStep ? 'done' : i === currentStep ? 'active' : 'pending'}`}>
                                                    {i < currentStep ? <span className="fa fa-check" style={{ fontSize: '0.75rem' }}></span> : i + 1}
                                                </div>
                                            </div>
                                            {i < STEPS.length - 1 && (
                                                <div className={`step-line ${i < currentStep ? 'done' : 'pending'}`}></div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>

                                <Form
                                    name="registerForm"
                                    validateOn="change"
                                    model="registerForm"
                                    onSubmit={(values) => this.handleRegister(values)}
                                >
                                    {/* Étape 0 — Identité */}
                                    {currentStep === 0 && (
                                        <>
                                            <p style={{ fontSize: '0.88rem', color: 'var(--gray)', marginBottom: 20 }}>
                                                <strong style={{ color: 'var(--dark)' }}>Étape 1/4</strong> — Comment vous appelez-vous ?
                                            </p>
                                            <div className="form-group mb-3">
                                                <Control.text model=".lastName" id="lastName" name="lastName"
                                                    placeholder="Nom de famille"
                                                    className="form-control auth-input"
                                                    validators={{ required, maxLength: maxLength(20) }}
                                                />
                                                <Errors className="errors" model=".lastName" show="touched"
                                                    messages={{ required: 'Champ requis.', maxLength: '20 caractères max.' }} />
                                            </div>
                                            <div className="form-group mb-4">
                                                <Control.text model=".firstName" id="firstName" name="firstName"
                                                    placeholder="Prénom"
                                                    className="form-control auth-input"
                                                    validators={{ required, maxLength: maxLength(20) }}
                                                />
                                                <Errors className="errors" model=".firstName" show="touched"
                                                    messages={{ required: 'Champ requis.', maxLength: '20 caractères max.' }} />
                                            </div>
                                            <Control.button className="btn btn-primary auth-submit mb-3"
                                                onClick={this.nextStepForm} model="registerForm" disabled={{ valid: false }}>
                                                Continuer
                                            </Control.button>
                                            <div className="auth-divider"><span>ou</span></div>
                                            <SocialLogin isNotAndroidPlatform={this.props.isNotAndroidPlatform} TokenDeviseRegister={this.props.TokenDeviseRegister} />
                                        </>
                                    )}

                                    {/* Étape 1 — Email + mot de passe */}
                                    {currentStep === 1 && (
                                        <>
                                            <p style={{ fontSize: '0.88rem', color: 'var(--gray)', marginBottom: 20 }}>
                                                <strong style={{ color: 'var(--dark)' }}>Étape 2/4</strong> — Vos informations de connexion
                                            </p>
                                            <div className="form-group mb-3">
                                                <Control.text model=".email" id="email" name="email"
                                                    placeholder="Adresse e-mail"
                                                    className="form-control auth-input"
                                                    autoFocus="true"
                                                    validators={{ required, validEmail }}
                                                />
                                                <Errors className="errors" model=".email" show="touched"
                                                    messages={{ required: 'Champ requis.', validEmail: 'Format invalide.' }} />
                                            </div>
                                            <div className="form-group mb-4">
                                                <Control.password model=".password" id="password" name="password"
                                                    placeholder="Mot de passe (8 caractères min.)"
                                                    className="form-control auth-input"
                                                    validators={{ required, maxLength: maxLength(30), minLength: minLength(8) }}
                                                />
                                                <Errors className="errors" model=".password" show="touched"
                                                    messages={{ required: 'Champ requis.', minLength: '8 caractères minimum.', maxLength: '30 caractères max.' }} />
                                            </div>
                                            <Control.button className="btn btn-primary auth-submit"
                                                onClick={this.nextStepForm} model="registerForm" disabled={{ valid: false }}>
                                                Continuer
                                            </Control.button>
                                        </>
                                    )}

                                    {/* Étape 2 — Date de naissance */}
                                    {currentStep === 2 && (
                                        <>
                                            <p style={{ fontSize: '0.88rem', color: 'var(--gray)', marginBottom: 20 }}>
                                                <strong style={{ color: 'var(--dark)' }}>Étape 3/4</strong> — Votre date de naissance
                                            </p>
                                            <div className="form-group mb-4">
                                                <Flatpickr
                                                    options={{
                                                        locale: French,
                                                        maxDate: 'today',
                                                        dateFormat: 'd/m/Y',
                                                        allowInput: true,
                                                    }}
                                                    value={this.state.birthDate}
                                                    onChange={(dates) => this.handleBirthDateChange(dates[0])}
                                                    className="form-control auth-input"
                                                    placeholder="JJ/MM/AAAA"
                                                />
                                            </div>
                                            <Button className="auth-submit" color="primary"
                                                onClick={this.nextStepForm}
                                                disabled={this.state.birthDate === null}>
                                                Continuer
                                            </Button>
                                        </>
                                    )}

                                    {/* Étape 3 — Téléphone */}
                                    {currentStep === 3 && (
                                        <>
                                            <p style={{ fontSize: '0.88rem', color: 'var(--gray)', marginBottom: 20 }}>
                                                <strong style={{ color: 'var(--dark)' }}>Étape 4/4</strong> — Votre numéro de téléphone
                                            </p>
                                            <div className="form-group mb-4">
                                                <Control.text model=".numberMobile" id="numberMobile" name="numberMobile"
                                                    placeholder="Ex : 0612345678"
                                                    autoFocus="true"
                                                    className="form-control auth-input"
                                                    validators={{ required, minLength: minLength(3), maxLength: maxLength(15), isNumber }}
                                                />
                                                <Errors className="errors" model=".numberMobile" show="touched"
                                                    messages={{ required: 'Champ requis.', minLength: '3 chiffres minimum.', isNumber: 'Chiffres uniquement.' }} />
                                            </div>
                                            <Control.button className="btn btn-primary auth-submit"
                                                disabled={{ valid: false }} model="registerForm" type="submit">
                                                Créer mon compte
                                            </Control.button>
                                        </>
                                    )}
                                </Form>

                                <div className="auth-footer mt-4">
                                    Déjà membre ?&nbsp;
                                    <Link to="/login" className="auth-link">Se connecter</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Register;
